<template>
    <v-app-bar app :color=color>
        <div class="d-flex d-lg-none">
            <v-app-bar-nav-icon
                @click.stop="$emit('drawer-change')"
            ></v-app-bar-nav-icon>
        </div>
        <v-toolbar-title class="white--text">
            {{titulo}}
        </v-toolbar-title>
    </v-app-bar>
</template>

<script>

export default {
	props: {
        color: String,
        titulo: String
    }
}

</script>